import { ICustomFormElement } from "./Abstract";

import { InputText } from "./Input";

class TextArea extends InputText implements ICustomFormElement {
    /**
     * @inheritDoc
     */
    initElements() {
        super.initElements();
        return this;
    }

    initShadow() {
        this.inputWrapper = this.querySelector<HTMLSpanElement>("span.input");
        if (this.inputWrapper) {
            this.input = document.createElement("textarea");
            this.input.name = this.getAttribute("name");
            if (this.hasAttribute("autocapitalize")) {
                this.input.autocapitalize = this.getAttribute("autocapitalize");
            }
            this.shadow = this.inputWrapper.attachShadow({ mode: "open" });
            this.shadow.appendChild(this.shadowStyle.content.cloneNode(true));
            this.shadow.appendChild(this.input);
        }
        return this;
    }

    /**
     * initialize attributes
     */
    initAttributes() {
        super.initAttributes();
        if (this.hasAttribute("cols")) {
            this.cols = this.getAttribute("cols");
        }
        if (this.hasAttribute("rows")) {
            this.rows = this.getAttribute("rows");
        }
        return this;
    }

    get cols() {
        return this.input.getAttribute("cols");
    }

    set cols(v) {
        if (!v && this.input.hasAttribute("cols")) {
            this.input.removeAttribute("cols");
        } else {
            this.input.setAttribute("cols", v);
        }
    }

    get rows() {
        return this.input.getAttribute("rows");
    }

    set rows(v) {
        if (!v && this.input.hasAttribute("rows")) {
            this.input.removeAttribute("rows");
        } else {
            this.input.setAttribute("rows", v);
        }
    }
}

TextArea.prototype.shadowStyle = document.createElement("template");
TextArea.prototype.shadowStyle = document.createElement("template");
TextArea.prototype.shadowStyle.innerHTML = /*html*/ `
<style>
textarea {
    accent-color: var(--shadow-input-accent-color, auto);
    background-color: var(--shadow-input-bg-color, transparent);
    border: var(--shadow-input-border, none);
    box-sizing: var(--shadow-input-box-sizing, border-box);
    cursor: var(--shadow-input-cursor, auto);
    display: var(--shadow-input-display, block);
    min-width: var(--shadow-input-min-width, 2rem);
    outline: var(--shadow-input-outline, none);
    padding-inline-end: var(--input-padding-inline);
    padding-block-end: var(--input-padding-block);
    resize: var(--shadow-input-resize, vertical);
    width: var(--shadow-input-width, auto);
    transition: padding var(--transition-duration-normal) var(--transition-timing-function-normal), margin var(--transition-duration-normal) var(--transition-timing-function-normal);
    font-size:  var(--shadow-input-font-size, 1rem);
    font-weight:  var(--shadow-input-font-weight, normal);
    font-family:  var(--shadow-input-font-family, sans-serif);
    line-height: var(--shadow-input-line-height, normal);
}
textarea::placeholder {
    color: var(--shadow-input-placeholder-color, transparent);
}
</style>
`;

TextArea.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
</label>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-textarea", TextArea);

export { TextArea };
